<script setup>
const { page } = defineProps({
    page: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <div class="template-blog-hero treat-as-hero">
        <div class="container">
            <ProjectBreadcrumbs light />
            <BlogHeadline :page="page" />
            <MessImage :key="page.data.image" :src="page.data.image" :alt="page.data.title" class="hero" />
        </div>
    </div>
</template>

<style lang="scss">
.template-blog-hero {
    --padding: calc(3.75rem + 1rem);
    //padding-top: calc(var(--padding) + var(--header-total));
    padding-top: calc( var(--header-height) );

    @media(min-width: $tablet) {
        margin-top: calc(var(--header-height) * -1);
        padding-top: calc(var(--header-height) + 3rem);
    }

    .mess-image {
        border-radius: var(--radius);
        overflow: hidden;
        max-width: 1130px;
        margin: 0 auto;
    }

    h2 {
        font-weight: 600;
    }
}
</style>
